export const CHAR_LIMIT_WHEN_ENABLED = 255;
